(() => {
  const selector = 'body.pb-home-index-active .jdgm-carousel__item-container';

  function attachDragScroll(container) {
    if (!container || container.dataset.pbReviewDragReady === 'true') return;
    container.dataset.pbReviewDragReady = 'true';

    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let suppressClick = false;

    container.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (container.scrollWidth <= container.clientWidth + 2) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = container.scrollLeft;
      moved = false;
      container.classList.add('pb-review-carousel-dragging');

      if (container.setPointerCapture) {
        try {
          container.setPointerCapture(pointerId);
        } catch (_error) {
          // Some embedded browsers can deny capture; dragging still works without it.
        }
      }
    });

    container.addEventListener(
      'pointermove',
      (event) => {
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) < 6 && !moved) return;

        moved = true;
        container.scrollLeft = startScrollLeft - deltaX;
        event.preventDefault();
      },
      { passive: false }
    );

    const endDrag = (event) => {
      if (pointerId !== event.pointerId) return;

      if (moved) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      }

      if (container.releasePointerCapture) {
        try {
          container.releasePointerCapture(pointerId);
        } catch (_error) {
          // Ignore release failures from embedded browser implementations.
        }
      }

      pointerId = null;
      moved = false;
      container.classList.remove('pb-review-carousel-dragging');
    };

    container.addEventListener('pointerup', endDrag);
    container.addEventListener('pointercancel', endDrag);
    container.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function init() {
    if (!document.body.classList.contains('pb-home-index-active')) return;
    document.querySelectorAll(selector).forEach(attachDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  const observer = new MutationObserver(init);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
